function getReplacement (search, replacement) {
    return {
        search,
        replace: `<strong class="v_brand">${replacement}</strong>`
    }
}

const names = [
    'Aflorazio',
    'Altissio',
    'Alto Dolce',
    'Alto Intenso',
    'Arondio',
    'Caramelizio',
    'Decaffeinato',
    'Decaffeinato Ontuoso',
    'Diavolitto',
    'Elvazio',
    'Fortado',
    'Giornio',
    'Halfcaffeinato',
    'Hazelino',
    'Melozio',
    'Odacio',
    'Solelio',
    'Stormio',
    'Vanizio',
    'Double Espresso Chiaro',
    'Double Espresso Scuro',
    'Voltesso',
    'Kazaar',
    'Dharkan',
    'Ristretto Decaffeinato',
    'Ristretto',
    'Arpeggio Decaffeinato',
    'Arpeggio',
    'Roma',
    'Livanto',
    'Capriccio',
    'Volluto Decaffeinato',
    'Volluto',
    'Cosi',
    'Vivalto Lungo Decaffeinato',
    'Envivo Lungo',
    'Fortissio Lungo',
    'Vivalto Lungo',
    'Linizio Lungo',
    'Master Origin India',
    'Decaffeinato Intenso',
    'Caramelito',
    'Ciocattino',
    'Vanilio',
    'Nicaragua',
    'Aeroccino3',
    'Aeroccino4',
    'Prodigio&Milk',
    'Prodigio',
    'Inissia bundles',
    'Inissia',
    'KitchenAid',
    'U bundles',
    'UMilk',
    'Pixie Clips',
    'Pixie bundles',
    'Pixie',
    'Citiz bundles',
    'Citiz&Milk',
    'Citiz',
    'Creatista Plus',
    'Creatista',
    'Essenza Mini',
    'Lattissima Pro',
    'Lattissima Touch',
    'Lattissima',
    'Gran Maestria',
    'Maestria',
    'Nespresso Professional',
    'Nespresso Expert&Milk',
    'Nespresso Expert',
    'Nespresso'
].map(name => getReplacement(name, name))

const customNames = [
    ['Indriya', 'from India'],
    ['Rosabaya', 'de Colombia'],
    ['Dulsão', 'do Brasil'],
    ['Bukeela', 'ka Ethiopia']
]

customNames.forEach(customName => names.push(getReplacement(customName.join(' '), customName[0] + ` <em>${customName[1]}</em>`)))

export default names
